@if (isOpen()) {
  <div
    #host
    class="picker-panel"
    (click)="$event.stopPropagation()"
  >
    <div class="picker-tabs">
      <button
        class="tab-btn"
        [class.active]="activeTab() === 'emoji'"
        (click)="selectTab('emoji')"
        type="button"
      >
        <span class="material-symbols-outlined">emoji_emotions</span>
        <span class="tab-label">{{ translateService.getTranslation(4236) }}</span>
      </button>
      <button
        class="tab-btn"
        [class.active]="activeTab() === 'gifs'"
        (click)="selectTab('gifs')"
        type="button"
      >
        <span class="material-symbols-outlined">gif_box</span>
        <span class="tab-label">{{ translateService.getTranslation(4237) }}</span>
      </button>
      <button
        class="tab-btn"
        [class.active]="activeTab() === 'stickers'"
        (click)="selectTab('stickers')"
        type="button"
      >
        <span class="material-symbols-outlined">sticky_note_2</span>
        <span class="tab-label">{{ translateService.getTranslation(4238) }}</span>
      </button>
      <button
        class="close-btn"
        (click)="onClose()"
        type="button"
      >
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="picker-body">
      @if (activeTab() === 'emoji') {
        <emoji-picker (emoji-click)="onEmojiClick($event)"></emoji-picker>
      } @else {
        <div class="search-bar">
          <span class="material-symbols-outlined">search</span>
          <input
            type="text"
            [placeholder]="
              activeTab() === 'gifs'
                ? translateService.getTranslation(4239)
                : translateService.getTranslation(4240)
            "
            [ngModel]="searchText()"
            (ngModelChange)="onSearchChange($event)"
          />
        </div>

        <div class="media-grid">
          @if (loading()) {
            <div class="status-row">...</div>
          } @else if (error() || items().length === 0) {
            <div class="status-row">
              {{ translateService.getTranslation(1033) }}
            </div>
          } @else {
            @for (item of items(); track item.id) {
              <button
                class="media-cell"
                (click)="onMediaClick(item)"
                type="button"
              >
                <img
                  [src]="item.previewUrl"
                  [alt]="item.title"
                  loading="lazy"
                />
              </button>
            }
          }
        </div>
      }
    </div>
  </div>
}
